
<p>async-observable works!</p>
<div><code>observable|async</code>: Time:
  <!--{{ dayObserver | async }}-->
</div>
